import { Grid, TextField, Button, MenuItem, AppBar, Tabs, Tab } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles'
import { validateEmail } from '../../../config/validations';
import { useForm, Controller } from "react-hook-form";
import CircularProgress from '@material-ui/core/CircularProgress';
import { useDispatch, useSelector } from "react-redux";
import SharedMembersTable from './MembersTable';
import { getBlueprintDetails } from "../../../store/global/selectors";
import { handleSnackBar } from "../../../store/global/actions";
import { useState, Fragment, useEffect } from 'react';
import BreadCrumb from '../../atoms/breadcrumb';
import TabPanel from '../../tabs/TabPanel';
import Colors from '../../../config/colors';
import TransferOwnership from './TransferOwnership';
import LeaveFromTeam from './LeaveFromTeam';
import { invokeGetService, invokePostService } from '../../../store/global/actions'

const useStyles = makeStyles({
    container: {
        margin: '90px 0px 0px',
        padding: '0px 15px',
        width: '100%',
    },
    shareContainer: {
        margin: '3px 0px 0px',
        padding: '0px 15px',
        width: '100%',
    },
    emailField: {
        '& .MuiInputBase-input': {
            fontWeight: 400,
        },
    },
    tableGrid: {
        marginTop: 10
    },
    tabWrapper: {
        alignItems: 'flex-start !important'
    },
    shareTab: {
        '& .MuiTabs-indicator': {
            display: 'none'
        }
    }
})

export default function Teams(props) {
    const { register, handleSubmit, formState: { errors }, control, reset } = useForm();
    const classes = useStyles()
    const dispatch = useDispatch();
    const blueprintDetails = useSelector(getBlueprintDetails);
    const [isSending, setIsSending] = useState(false);
    const [sharedMembers, setSharedMembers] = useState(null);
    const [isPrimaryUser, setIsPrimaryUser] = useState(false);
    const [isTransferOwnership, setIsTransferOwnership] = useState(false);
    const [isTransferAndLeave, setIsTransferAndLeave] = useState(false);
    const [isLeave, setIsLeave] = useState(false);
    const [isAdminUser, setIsAdminUser] = useState(false);
    const accessLevels = [{ title: 'Admin', value: 'ADMIN' }, { title: 'Viewer', value: 'VIEWER' }, { title: 'Editor', value: 'EDITOR' }];
    const getSharedList = () => {
        setSharedMembers(null);

        dispatch(invokeGetService('getBlueprintSharedMembers', [])).then(res => {
            if (res?.status == true) {
                const sortedData = res.data.sort((a, b) => {
                    if (a.access_level === 'OWNER') {
                        return -1; // if a is owner, it should come first
                    } else if (b.access_level === 'OWNER') {
                        return 1; // if b is owner, it should come first
                    } else {
                        // If neither is owner, sort by firstName
                        const nameA = a.userId.firstName.toUpperCase();
                        const nameB = b.userId.firstName.toUpperCase();
                        if (nameA < nameB) {
                            return -1;
                        }
                        if (nameA > nameB) {
                            return 1;
                        }
                        return 0;
                    }
                });
                setSharedMembers(sortedData);
            } else {
                setSharedMembers([]);
            }
            setIsPrimaryUser(res?.isPrimaryUser);
            setIsAdminUser(res?.isAdminUser);
        });
    }

    useEffect(() => {
        getSharedList();
    }, [props]);


    const onSendInvitation = ({ email, accessLevel }) => {

        setIsSending(true);
        const host = window.location.hostname;
        const port = window.location.port;
        dispatch(invokePostService('sendInvitation', { payload: { email, host, port, accessLevel } })).then(res => {
            setIsSending(false);
            if (res?.status == true) {
                reset({ email: ""});
                getSharedList();
                dispatch(handleSnackBar({ open: true, message: res?.message, severity: "success" }));
            } else if (res?.level === "warning") {
                getSharedList();
                reset({ email: ""});
                dispatch(handleSnackBar({ open: true, message: res?.message, severity: "warning" }));
            } else {
                dispatch(handleSnackBar({ open: true, message: res?.message, severity: "error" }));
            }
        });
    }

    const onTransferOwnership = () => {
        setIsTransferOwnership(true);
    }

    const onLeaveFromTeam = () => {
        if (isPrimaryUser) {
            setIsTransferAndLeave(true);
        } else {
            setIsLeave(true);
        }
    }

    return (
        <Grid container className={classes.container} spacing={1}>
            <Grid item xs={12}>
                <BreadCrumb items={[{ label: 'Team' }]} isHeading={true}/>
            </Grid>
            <Grid item xs={12}>
                {(isPrimaryUser || isAdminUser) &&
                    <>
                        <AppBar position="static">
                            <Tabs
                                variant="fullWidth"
                                value={0}
                                aria-label="nav tabs share"
                                className={classes.shareTab}
                            >
                                <Tab label="Share blueprint" style={{textTransform: 'capitalize'}} classes={{
                                    wrapper: classes.tabWrapper
                                }} />
                            </Tabs>
                        </AppBar>
                        <TabPanel value={0} index={0} style={{ border: `3px solid ${Colors.primary}`, borderTop: 'none' }}>
                            <Grid container className={classes.shareContainer} spacing={1}>
                                <Grid item xs={3}>
                                    <TextField
                                        name="email"
                                        fullWidth
                                        type={"text"}
                                        required={true}
                                        label={"Email Address"}
                                        placeholder={"Enter email to share"}
                                        variant="outlined"
                                        size={'small'}
                                        inputRef={register({ required: true, validate: validateEmail })}
                                        className={classes.emailField}
                                        error={errors.email ? true : false}
                                        helperText={errors?.email?.type === 'required' ? 'Email address is required' : errors?.email?.type === 'validate' ? 'Email address is invalid' : ''}
                                        InputLabelProps={{
                                            shrink: true
                                        }}
                                    />
                                </Grid>
                                <Grid item xs={2}>
                                    <Controller
                                        name="accessLevel"
                                        control={control}
                                        defaultValue={'EDITOR'}
                                        rules={{ required: true }}
                                        render={({ field, value, onChange }) =>
                                            <TextField
                                                {...field}
                                                name="accessLevel"
                                                label={'Access level'}
                                                select
                                                fullWidth
                                                variant={'outlined'}
                                                size={'small'}
                                                value={value}
                                                error={errors.accessLevel ? true : false}
                                                helperText={errors?.accessLevel ? 'Access level is required' : ''}
                                                onChange={e => { onChange(e) }}
                                            >
                                                <MenuItem key={123} value={""}>Select</MenuItem>
                                                {accessLevels.map((option) => (
                                                    <MenuItem key={option.value} value={option.value}>
                                                        {option.title}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        }
                                    />
                                </Grid>
                                <Grid item xs={1}>
                                    <Button id='invite_btn' onClick={handleSubmit(onSendInvitation)} endIcon={isSending ? <CircularProgress size={10} /> : <Fragment />} disabled={isSending} color="primary" variant="contained" style={{ marginTop: 0, height: 38, textTransform: 'capitalize' }}>
                                        {isSending === true ? 'Sharing..' : 'Share'}
                                    </Button>
                                </Grid>
                            </Grid>
                        </TabPanel>
                    </>
                }
            </Grid>

            <Grid item xs={12} style={{ display: 'flex', justifyContent: "end" }}>
                {isPrimaryUser && <Button id='transfer_ownership' onClick={onTransferOwnership} variant="contained" style={{textTransform: 'capitalize'}} >Transfer Ownership</Button>}
                <Button style={{ marginLeft: 5, textTransform: 'capitalize' }} onClick={onLeaveFromTeam} id='leave_team' variant="contained">Leave</Button>
            </Grid>

            <Grid item xs={12} className={classes.tableGrid}>
                <SharedMembersTable getSharedList={getSharedList} sharedMembers={sharedMembers} isAdminUser={isAdminUser} isPrimaryUser={isPrimaryUser} />
            </Grid>

            {((isTransferOwnership || isTransferAndLeave) && sharedMembers !== null) && <TransferOwnership setIsTransferOwnership={setIsTransferOwnership} sharedMembers={sharedMembers} getSharedList={getSharedList} isTransferAndLeave={isTransferAndLeave} setIsTransferAndLeave={setIsTransferAndLeave} />}
            {isLeave && <LeaveFromTeam isLeave={isLeave} setIsLeave={setIsLeave} sharedMembers={sharedMembers} blueprintDetails={blueprintDetails} getSharedList={getSharedList} />}
        </Grid>
    )
}